/**
 * Client-side password salting, matching the server contract used by the
 * v1 storefront (`client/src/services/users/users.service.tsx`): password is
 * hashed with the normalized email as salt before it ever leaves the browser.
 */
export async function hashPassword(password: string, salt: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(password + salt);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(digest)).map(byte => byte.toString(16).padStart(2, "0")).join("");
}

export function normalizeEmail(email: string): string {
    return email.trim().toLowerCase();
}
